import { envConfig } from 'config/config'

const STRICTLY_NECESSARY_GROUP = 'C0001'

const parseGroups = (value?: string): string[] => {
  if (!value) {
    return []
  }

  return value
    .split(',')
    .map((group) => group.trim())
    .filter(Boolean)
}

const getActiveGroups = (): string[] => {
  if (typeof window === 'undefined') {
    return []
  }

  const rawGroups =
    window.OptanonActiveGroups || window.OnetrustActiveGroups || ''

  return parseGroups(rawGroups)
}

export const hasNonEssentialStorageConsent = (): boolean => {
  const activeGroups = getActiveGroups()

  if (activeGroups.length === 0) {
    return false
  }

  const configuredGroups = parseGroups(
    envConfig.config.ONETRUST_FUNCTIONAL_GROUPS,
  )

  if (configuredGroups.length > 0) {
    return configuredGroups.some((group) => activeGroups.includes(group))
  }

  return activeGroups.some((group) => group !== STRICTLY_NECESSARY_GROUP)
}

export const onOneTrustConsentChanged = (handler: () => void): (() => void) => {
  if (typeof window === 'undefined') {
    return () => undefined
  }

  window.addEventListener('OneTrustConsentChanged', handler)

  return () => window.removeEventListener('OneTrustConsentChanged', handler)
}
